// URL <-> page state for Issue Analytics, so a view can be shared or bookmarked.
// Only values that differ from the defaults are written, keeping links short.

import { MIN_VOLUME_OPTIONS } from "./stats";

export const PRESETS = ["7", "30", "90", "all", "custom"];
export const DATE_BASES = ["created", "updated"];
export const GROUPINGS = ["family", "title"];

export const URL_DEFAULTS = {
  preset: "30",
  start: "", // YYYY-MM-DD, custom preset only
  end: "",
  basis: "created",
  group: "family",
  minVolume: 0,
  agent: "", // selected agent group key
  variant: "", // selected scan title inside the agent group
  client: "", // selected website id
  reason: "", // selected discard-reason category id
  sites: null, // null = the default paying set; [] = nothing selected
};

const oneOf = (value, allowed, fallback) => (allowed.includes(value) ? value : fallback);
const isoDate = (value) => (/^\d{4}-\d{2}-\d{2}$/.test(value || "") ? value : "");

export function parseUrlState(params) {
  const get = (k) => (params && params.get ? params.get(k) : null);
  const minVolume = parseInt(get("min") || "0", 10);
  const sitesRaw = get("sites");
  return {
    preset: oneOf(get("range"), PRESETS, URL_DEFAULTS.preset),
    start: isoDate(get("start")),
    end: isoDate(get("end")),
    basis: oneOf(get("basis"), DATE_BASES, URL_DEFAULTS.basis),
    group: oneOf(get("group"), GROUPINGS, URL_DEFAULTS.group),
    minVolume: MIN_VOLUME_OPTIONS.includes(minVolume) ? minVolume : URL_DEFAULTS.minVolume,
    agent: get("agent") || "",
    variant: get("variant") || "",
    client: get("client") || "",
    reason: get("reason") || "",
    sites: sitesRaw == null ? null : sitesRaw.split(",").filter(Boolean),
  };
}

// Returns the query entries for a state; defaults are omitted.
export function serializeUrlState(state) {
  const out = {};
  if (state.preset !== URL_DEFAULTS.preset) out.range = state.preset;
  if (state.preset === "custom") {
    if (state.start) out.start = state.start;
    if (state.end) out.end = state.end;
  }
  if (state.basis !== URL_DEFAULTS.basis) out.basis = state.basis;
  if (state.group !== URL_DEFAULTS.group) out.group = state.group;
  if (state.minVolume) out.min = String(state.minVolume);
  if (state.agent) out.agent = state.agent;
  if (state.variant) out.variant = state.variant;
  if (state.client) out.client = state.client;
  if (state.reason) out.reason = state.reason;
  if (Array.isArray(state.sites)) out.sites = state.sites.join(",");
  return out;
}
